"use client";

import ContactForm from "../forms/contact-form";
import { MapPin, Phone, Mail, Facebook, Instagram, Twitter, Youtube } from "lucide-react";
import styles from "./contact.module.css";

const contactInfo = [
  {
    id: 1,
    icon: MapPin,
    title: "Main Office",
    subtitle: "17/6, Eskaton Garden Road, Magbazar, Dhaka.",
  },
  {
    id: 2,
    icon: Phone,
    title: "Phone Number",
    subtitle: "+88-01315994499",
    link: "tel:+8801315994499",
  },
  {
    id: 3,
    icon: Mail,
    title: "Email Address",
    subtitle: "imall.com.bd@gmail.com",
    link: "mailto:imall.com.bd@gmail.com",
  },
];

const socialLinks = [
  {
    id: 1,
    name: "Facebook",
    icon: Facebook,
    link: "https://facebook.com",
    bgGradient: "linear-gradient(135deg, #1877f2 0%, #0c63d4 100%)",
  },
  {
    id: 2,
    name: "Instagram",
    icon: Instagram,
    link: "https://instagram.com",
    bgGradient: "linear-gradient(135deg, #E1306C 0%, #C13584 50%, #833AB4 100%)",
  },
  {
    id: 3,
    name: "Twitter",
    icon: Twitter,
    link: "https://twitter.com",
    bgGradient: "linear-gradient(135deg, #1DA1F2 0%, #0c85d0 100%)",
  },
  {
    id: 4,
    name: "YouTube",
    icon: Youtube,
    link: "https://youtube.com",
    bgGradient: "linear-gradient(135deg, #FF0000 0%, #cc0000 100%)",
  },
];

const ContactArea = () => {
  return (
    <section className={styles.contactArea}>
      <div className={styles.container}>
        {/* Header */}
        <div className={styles.contactHeader}>
          <div className={styles.badge}>
            <Mail size={16} />
            <span>Get In Touch</span>
          </div>
          <h2 className={styles.contactTitle}>Contact Us</h2>
          <p className={styles.contactSubtitle}>
            Have questions or need assistance? We're here to help! Reach out to us through any of the channels below.
          </p>
        </div>

        <div className={styles.contactGrid}>
          {/* Contact Info Card */}
          <div className={styles.contactCard}>
            <h3 className={styles.cardTitle}>Get In Touch</h3>

            <div className={styles.contactList}>
              {contactInfo.map((item) => {
                const IconComponent = item.icon;
                return (
                  <div key={item.id} className={styles.contactItem}>
                    <div className={styles.contactIcon}>
                      <IconComponent size={22} />
                    </div>
                    <div className={styles.contactContent}>
                      <h6>{item.title}</h6>
                      {item.link ? (
                        <a href={item.link} className={styles.contactLink}>
                          {item.subtitle}
                        </a>
                      ) : (
                        <span>{item.subtitle}</span>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Social Links */}
            <div className={styles.socialSection}>
              <h4 className={styles.socialTitle}>Follow Us</h4>
              <div className={styles.socialLinks}>
                {socialLinks.map((social) => {
                  const IconComponent = social.icon;
                  return (
                    <a
                      key={social.id}
                      href={social.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.socialLink}
                      style={{ background: social.bgGradient }}
                      title={social.name}
                    >
                      <IconComponent size={20} color="#fff" />
                    </a>
                  );
                })}
              </div>
            </div>

            {/* Working Hours */}
            <div className={styles.workingHours}>
              <h4 className={styles.hoursTitle}>Delivery Hours</h4>
              <div className={styles.hoursList}>
                <div className={styles.hoursItem}>
                  <span className={styles.day}>Everyday</span>
                  <span className={styles.time}>9:00 AM - 10:00 PM</span>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form Card */}
          <div className={styles.contactCard}>
            <h3 className={styles.cardTitle}>Send Us a Message</h3>
            <p className={styles.formDescription}>
              Fill out the form below and we'll get back to you as soon as possible.
            </p>
            <ContactForm />
            <p className={styles.ajaxResponse}></p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactArea;